import { BattleCardView } from "@/types/battle"
import { GuardianCard } from "@/components/GuardianCard"

interface CardPickerProps {
  cards: BattleCardView[]
  disabled?: boolean
  onSelect: (card: BattleCardView) => void
}

export default function CardPicker({
  cards,
  disabled,
  onSelect,
}: CardPickerProps) {
  return (
    <ul className="grid grid-cols-2 gap-2 sm:grid-cols-3">
      {cards.map((card) => (
        <li key={card.id} className="flex justify-center">
          <GuardianCard
            card={card}
            size="sm"
            onClick={disabled ? undefined : () => onSelect(card)}
          />
        </li>
      ))}
    </ul>
  )
}
